import {
  CREATE_PLC_SAFETY_ZONE_DEPENDENCY,
  CREATE_PLC_SAFETY_ZONE_DEPENDENCY_SUCCESSFUL,
  CREATE_PLC_SAFETY_ZONE_DEPENDENCY_FAILED,
} from './actionTypes';

export const createPlcSafetyZoneDependency = (zoneDependency) => ({
  type: CREATE_PLC_SAFETY_ZONE_DEPENDENCY,
  payload: { zoneDependency },
});

export const createPlcSafetyZoneDependencySuccessful = (message) => ({
  type: CREATE_PLC_SAFETY_ZONE_DEPENDENCY_SUCCESSFUL,
  payload: message,
});

export const createPlcSafetyZoneDependencyFailed = (message) => ({
  type: CREATE_PLC_SAFETY_ZONE_DEPENDENCY_FAILED,
  payload: message,
});
